class Api {
  constructor() {
    this.standByTimer = null
  }
  _init = async () => {
    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()
    return true
  }

  addListeners = () => {
    document.addEventListener("hcap_application_focus_changed", _$.handler.emit, false)
    document.addEventListener("channel_changed", _$.handler.emit, false)
    document.addEventListener("channel_status_changed", _$.handler.emit, false)
    document.addEventListener("media_event_received", _$.handler.emit, false)
    document.addEventListener("external_input_changed", _$.handler.emit, false)
    document.addEventListener("hcap_application_focus_changed", _$.handler.emit, false)
    document.addEventListener("power_mode_changed", _$.handler.emit, false)
    document.addEventListener("udp_data_received", _$.handler.emit, false)
    document.addEventListener("tcp_data_received", _$.handler.emit, false)

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.source && __.media.request(true)))

    _$.vue.$on("standBy", async () => {
      if (__.media.isPlaying()) await __.media.request(true).then(() => __.media.stop())
      else if (!__.source.isPlatformSource()) __.platform.toPlatform()

      _$.nav.disable()
      if (this.standByTimer) clearTimeout(this.standByTimer)
      this.standByTimer = setTimeout(() => !__.device.isPowerOn() && __.platform.go(), 60000)
    })
    _$.vue.$on("powerOn", () => _$.sleep(1000).then(() => __.media.request().then(() => _$.nav.enable())))
  }
  makeConfigurations = async () => {
    let promise

    if (hcap.property.getHotelMode) {
      promise = await _$.progress.create()
      hcap.property.getHotelMode({
        onSuccess: payload => {
          let hotelMode = JSON.parse(payload.hotelMode)
          hotelMode.enable = "on"
          hotelMode.settings.limitedMode.enable = "on"
          hotelMode.settings.limitedMode.settings.setupMenu = "off"
          hotelMode.settings.limitedMode.settings.programmeChange = "off"
          hotelMode.settings.limitedMode.settings.menuDisplay = "off"
          hotelMode.settings.limitedMode.settings.osdDisplay = "on"
          hotelMode.settings.limitedMode.settings.systemProviderMode = "off"

          hcap.property.setHotelMode({
            hotelMode: JSON.stringify(hotelMode),
            onSuccess: () => promise.resolve(),
            onFailure: payload => promise.reject(payload.errorMessage)
          })
        },
        onFailure: payload => promise.reject(payload.errorMessage)
      })
      await promise.done
    }

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "instant_power",
      value: "1",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "security_level",
      value: "2",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "tv_channel_control",
      value: "0",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "wifi_screen_share",
      value: "1",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "tv_channel_attribute_floating_ui",
      value: "0",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.property.setProperty({
      key: "boot_sequence_option",
      value: "1",
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    await promise.done

    promise = await _$.progress.create()
    hcap.socket.openTcpDaemon({
      port: 4000,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })

    await promise.done

    promise = await _$.progress.create()
    hcap.socket.openUdpDaemon({
      port: 4000,
      onSuccess: () => promise.resolve(),
      onFailure: payload => promise.reject(payload.errorMessage)
    })

    return promise.done
  }
  loadResources = async () => {
    _$.loader.createScript({
      src: "/procentric/assets/hcap-1.24.js"
    })
    return true
  }
  getProperties = async property => {
    try {
      if (!property) return false
      if (property === "ip_address") return this._getIPaddress()

      let promise = await _$.progress.create()
      hcap.property.getProperty({
        key: property,
        onSuccess: payload => promise.resolve(payload.value),
        onFailure: payload => promise.reject(payload.errorMessage)
      })
      return promise.done
    } catch (err) {
      return _$.error(err)
    }
  }
  setProperties = async (property, value = false) => {
    try {
      if (!property) return false

      let promise = await _$.progress.create()
      hcap.property.setProperty({
        key: property.toString(),
        value: value.toString(),
        onSuccess: () => promise.resolve(value.toString()),
        onFailure: payload => promise.reject(payload.errorMessage)
      })
      return promise.done
    } catch (err) {
      return _$.error(err)
    }
  }
  _getIPaddress = async (index = 0) => {
    try {
      let promise = await _$.progress.create()

      hcap.network.getNetworkDevice({
        index: index,
        onSuccess: payload => {
          if (!index && payload.ip === "0.0.0.0") promise.resolve(__._api._getIPaddress(1))
          else if (payload.ip === "0.0.0.0") promise.reject()
          else promise.resolve(payload.ip)
        },
        onFailure: () => {
          hcap.network.getNetworkInformation({
            onSuccess: payload => promise.resolve(payload.ip_address),
            onFailure: payload => promise.reject(payload.errorMessage)
          })
        }
      })

      return promise.done
    } catch (err) {
      return _$.error(err)
    }
  }
  checkOut() {
    _$.sleep(3000).then(() => __.device.reboot())
  }
}

export default Api
